import React, { useEffect, useState } from "react";
import ItemQuantity from "../../components/ItemQuantity/ItemQuantity";

const ItemQuantityContainer = ({
	component,
	handleProductsToAddToCart,
	initial,
}) => {
	const [options, setOptions] = useState([]);
	const [quantity, setQuantity] = useState(initial);

	const getOptions = (stock) => {
		let values = [];
		for (let i = 0; i <= stock; i++) {
			values.push(i);
		}
		return values;
	};
	const handleQuantity = (evt) => {
		setQuantity(evt.target.value);
	};

	useEffect(() => {
		if (handleProductsToAddToCart && initial !== quantity) {
			handleProductsToAddToCart(component.idComponent, quantity);
		}
	}, [component.idComponent, handleProductsToAddToCart, initial, quantity]);

	useEffect(() => {
		setOptions(() => getOptions(component.stock));
	}, [component]);

	return (
		<ItemQuantity
			quantities={options}
			quantity={quantity}
			handleQuantity={handleQuantity}
		/>
	);
};

export default ItemQuantityContainer;
